<template>
  <div class="moow-master-container play-background">
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container fluid class="filter-container-hero">
      <div class="container vert-cent">
        <b-row>
          <b-col lg="6" md="6" sm="10">
            <md-card md-with-hover class="mt-5 island-card">
              <md-card-header style="text-align:center;" class="mt-5">
                <md-progress-spinner
                  v-if="loadingInvitation"
                  class="md-accent"
                  md-mode="indeterminate"
                ></md-progress-spinner>
                <b-row v-else-if="formTitle">
                  <b-col>
                    <p class="moow-hero-title center mb-2">
                      Join
                      <strong>{{formTitle}}</strong>
                    </p>
                    <p>
                      Already have an account?
                      <router-link to="login">Log In here</router-link>
                    </p>
                  </b-col>
                </b-row>
              </md-card-header>

              <md-card-content style="text-align:center;" v-if="!inviteErr">
                <register-form
                  v-if="!loadingInvitation"
                  :emailForced="emailForced"
                  :accountIdForced="accountIdForced"
                  :inviterUidForced="inviterUidForced"
                  :inviteeRole="inviteeRole"
                  :nameForced="nameForced"
                  :invitedToDealId="invitedDealId"
                  @emitSuccessfulRegistration="successfulRegistration"
                  @emitFailedRegistration="failedRegistration"
                  @emitLoading="toggleLoading"
                ></register-form>
              </md-card-content>
              <md-card-content style="text-align:center;" v-else>
                <md-empty-state
                  class="md-accent"
                  md-rounded
                  md-icon="alarm_off"
                  md-label="Invite Not Available"
                  md-description="Either revoked, used or expired. Contact your organization administrator."
                ></md-empty-state>
              </md-card-content>
            </md-card>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import Snackbar from "@/components/snackbar.vue";
import TermsAndConditions from "@/components/dialogs/TermsAndConditions.vue";
import RegisterForm from "./registerForm.vue";
import { getInvitationByEncryptedId } from "@/platform/account/repositories/accountRepository.js";
import {
  captureMessage,
  captureException
} from "@/utils/reporting/reportingService.js";
export default {
  props: {
    connectToPersonId: {
      type: String,
      required: false
    }
  },
  name: "Register",
  components: {
    snackbar: Snackbar,
    "register-form": RegisterForm
  },
  data() {
    return {
      loadingInvitation: true,
      loading: false,
      accountIdForced: undefined,
      inviterUidForced: undefined,
      emailForced: undefined,
      invitorName: undefined,
      inviterUid: undefined,
      inviteErr: undefined,
      inviteeRole: undefined,
      nameForced: undefined,
      invitedDealId: undefined
    };
  },
  created() {
    if (this.$store.getters.isUserLoggedIn)
      this.navigateTo({ name: "dashboard" });
    else if (this.$route.query.invitation) {
      this.getInvitation(this.$route.query.invitation);
    }
  },
  watch: {},
  computed: {
    formTitle() {
      if (!this.invitedDealId && this.invitorName) return this.invitorName;
      if (this.invitedDealId) return "a Deal";
      return "Moowle";
    }
  },
  methods: {
    async getInvitation(encInviteId) {
      try {
        this.loadingInvitation = true;
        var invite = await getInvitationByEncryptedId(decodeURI(encInviteId));
        this.nameForced = invite.inviteeName;
        this.emailForced = invite.inviteeEmail;
        this.invitorName = invite.invitorName;
        this.inviterUid = invite.inviterUid
        if (invite.type && invite.type == "dealInvitation"){
          this.invitedDealId = invite.invitedDealId;
          this.inviterUidForced = invite.inviterUid
        }
        else {
          this.accountIdForced = invite.invitedAccountId;
          this.inviteeRole = invite.inviteeRole;
        }
      } catch (error) {
        this.inviteErr = error;
      } finally {
        this.loadingInvitation = false;
      }
    },
    toggleLoading(value) {
      this.loading = value;
    },
    successfulRegistration() {
      this.redirect();
    },
    failedRegistration(error) {
      this.toggleLoading(false);
    },
    redirect() {
      let redirectComponent = this.$route.query.redirect;
      if (!redirectComponent) {
        this.invitedDealId
          ? (redirectComponent = "stays")
          : (redirectComponent = "dashboard");
      }
      this.navigateTo({ name: redirectComponent });
    },
    navigateTo({ name, params }) {
      var parameters
      if (name === "chat") {
        parameters = {
          chatWithThisUser: this.chatWithThisUser,
          initialChatMsg: this.initialChatMsg,
          regardingPropery: this.regardingPropery
        }
      }else {
        parameters = params
      }
      this.$router.push({
        name: name,
        params: parameters
      });
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/auth/InviteRegister.vue